const urlRegex = new RegExp(
    '^(' +
    // HTTP/HTTPS URL
    '(https?:\\/\\/)' +
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // 도메인 이름
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // 또는 IP 주소
    '(\\:\\d+)?(\\/[^\\s<>\"{}|\\\\^`\\[\\]]*)*' + // 포트 번호 및 경로 (URL 인코딩된 문자 포함)
    '(\\?[^\\s<>\"{}|\\\\^`\\[\\]#]*)?' + // 쿼리 파라미터
    '(\\#[^\\s<>\"{}|\\\\^`\\[\\]]*)?|' + // 해시 / 프래그먼트
    
    // File URL (file:///)
    'file:\\/\\/\\/' +
    '([a-zA-Z]:\\\\|\\/)?' + // Windows 드라이브 문자 (C:\) 또는 Unix 루트 (/)
    '[^<>:\"*?|\\n\\r\\t]*' + // 파일 경로 (Windows에서 금지된 문자 제외)
    ')$',
    'i' // 대소문자 구분 없음
);
// 사용 예시
function isValidURL(url) {

    try {
        // 입력이 문자열인지 확인
        if (typeof url !== 'string' || url.trim() === '') {
            return false;
        }
        
        return urlRegex.test(url);
    } catch (e) {
        return false;
    }
}

export {isValidURL}
